'use client';

import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { rowStyles } from 'bouqei';

const Main = styled.main`
  ${rowStyles('flex-start', 'flex-start')};
  width: 100%;
`;

export const MainContained: React.FC<PropsWithChildren> = ({ children }) => {
  return <Main>{children}</Main>;
};

export default Main;
